import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const ContentAccordion = ({ 
  title, 
  summary,
  children,
  defaultOpen = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border border-gray-100 rounded-xl overflow-hidden bg-white ${className}`} data-testid="content-accordion">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 flex items-start justify-between gap-3 text-left hover:bg-gray-50 transition-colors"
        data-testid="accordion-trigger"
      >
        <div className="flex-1">
          <h4 className="font-heading font-semibold text-[var(--primary)]">{title}</h4>
          {summary && !isOpen && (
            <p className="text-sm text-gray-500 mt-1 line-clamp-2">{summary}</p>
          )}
        </div>
        <ChevronDown 
          className={`w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`} 
        />
      </button>
      
      {isOpen && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <div className="pt-3 prose prose-sm max-w-none">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentAccordion;
